export const WorkflowTypeEnum = {
  CKYC: "CKYC",
  AADHAAR: "AADHAAR",
};
